import { AdminFee } from './AdminFee';
export default AdminFee;